//Libraries
import React from "react";
import { connect } from "react-redux";

// Local Libraries
import phrasebookLoad from "../../i18n";
import * as token from '../../helpers/token';
import { accountTypesConstants, portalFunctionalityConstants, permissionTypeConst } from '../../constants';
import { capitalizeFirstLetter, permissionFinder } from "../../helpers/util"


//Redux
import { notificationActions } from 'actions';

//Componenets
import { Table } from "../../components/SkyFramework/Tables/Table.jsx";
import { PaginationBar } from "../../components/SkyFramework/Pagination/PaginationBar.jsx";
import { NewBreadcrumbs } from "../../components/SkyFramework/Breadcrumbs/NewBreadcrumbs";
import { SearchBox } from "../../components/SkyFramework/Search";

//Routes
import { gisRoutes } from "../../routes/routes";

// Constants
const phrasebook = phrasebookLoad()

class Notifications extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      notifications: undefined,
      filters: { receiver_account_id: this.props.authUser.id, orderby: 'notification_read' },
      limit: 10,
      page: 1
    };

    this.account_type_logged = accountTypesConstants[token.loggedAccountType()];
    // this.handleSearchSubmit = this.handleSearchSubmit.bind(this);
    // this.handleChange = this.handleChange.bind(this);
    // this.handleDeleteSubmit = this.handleDeleteSubmit.bind(this);
  }

  componentDidMount() {
    this.props.dispatch(notificationActions.getAll(this.state.limit, 0, this.state.filters));
  }

  componentDidUpdate(prevProps) {
    if (this.props.notifications && prevProps && prevProps.notifications !== this.props.notifications) {
      this.setState({ notifications: this.props.notifications });
    }
  }

  onPageChanged = currentPage => {
    this.setState({ page: currentPage });
    this.props.dispatch(notificationActions.getAll(this.state.limit, currentPage - 1, this.state.filters));
  }

  SearchBox() {
    var filters = [[
      { label: phrasebook.common.status, type: "select", id: "status", tooltip: 'Status of the notification', name: "status", options: this.state.status_list, empty_option: true },
      { label: phrasebook.common.disabled, type: "select", id: "disabled", tooltip: 'Disabled/Enabled', name: "disabled", options: this.state.disabled_list, empty_option: true }],
    ]
    if (this.state.account_types && token.loggedAccountType() < 200 && this.state.customers) {
      const accountOptions = this.state.account_types.map(function (account_type) {
        return { value: account_type['id'], label: capitalizeFirstLetter(account_type['account_type']) };
      });
      const customerOptions = this.state.customers.map(function (customer) {
        return { value: customer['id'], label: capitalizeFirstLetter(customer['name']) };
      });
      filters.push({
        label: phrasebook.profile.account_type, type: "select", id: "account_type_code",
        tooltip: 'toto1', name: "account_type_code", options: accountOptions, empty_option: true
      })
      filters.push({ label: phrasebook.common.customer, type: "select", id: "customer_id", tooltip: 'toto2', name: "customer_id", options: customerOptions, empty_option: true })
      return (
        <SearchBox
          filters={filters}
          buttonTitle={phrasebook.common.search}
          onClick={this.handleSearchSubmit}
          onChange={this.handleChange}
        />)
    } else if (this.state.account_types && token.loggedAccountType() >= 200) {
      const accountOptions = this.state.account_types.map(function (account_type) {
        return { value: account_type['id'], label: capitalizeFirstLetter(account_type['account_type']) };
      });
      filters.push({
        label: phrasebook.profile.account_type, type: "select", id: "account_type_code",
        tooltip: 'toto1', name: "account_type_code", options: accountOptions, empty_option: true
      })
      return (
        <SearchBox
          filters={filters}
          buttonTitle={phrasebook.common.search}
          onClick={this.handleSearchSubmit}
          onChange={this.handleChange}
        />)
    } else return null;
  }

  NotificationList = () => {
    let labels = [
      phrasebook.common.customer,
      phrasebook.common.title,
      phrasebook.common.status,
      phrasebook.common.read_question,
      phrasebook.common.created_at
    ];
    const keys = [['creator_customer', 'name'], 'notification_title', 'notification_status', 'notification_read', 'createdAt']
    if (this.state.notifications) {
      let notifications = this.state.notifications.data;
      return (<div>
        <br></br>
        <Table
          headers={labels}
          keys={keys}
          values={notifications}
          nofound={phrasebook.common.nodatafound}
          actions={[{
            location: gisRoutes.notification.notification.read,
            label: phrasebook.common.read,
            type: 'link'
          }]}
          action_key={'id'} />
        <PaginationBar limit={this.state.limit}
          total={this.state.notifications.count}
          currentPage={this.state.page}
          onPageChanged={this}
          pageNeighbours={this.state.pageNeighbours} />
      </div>)
    } else return null;
  }

  render = () => {
    const { notifications } = this.props;
    if (notifications) {
      this.state.notifications = notifications;
    }
    return <>
      <NewBreadcrumbs crumbs={[{ link: gisRoutes.dashboard[this.account_type_logged], label: phrasebook.common.home }]} current={phrasebook.notifications.notifications} />

      <div className="box p-1 p-sm-2">
        <h2 className="box-title pb-1 mb-1">{phrasebook.notifications.notifications}</h2>
        {/* {this.SearchBox()} */}
      </div>
      <div className="box p-1 p-sm-2 my-md-1">
        <h3 className="box-title pb-1 mb-1">{phrasebook.notifications.notifications}</h3>
        {this.NotificationList()}
      </div>
    </>
  }
}

function mapStateToProps(state) {
  const { authentication, notification } = state;
  const { authUser } = authentication;
  return {
    authUser,
    notifications: notification.notifications
  };
}

const notifications = connect(mapStateToProps)(Notifications);
export default notifications;
